import type { UserDto } from "../../../common/model/userDto";
import ConnectedService from "./ConnectedService";

export default class User {
  constructor(
    public id: string,
    public name: string,
    public email: string = "",
    public userName: string = "",
    public connectedServices: ConnectedService[],
  ) {}

  static fromDto(u: UserDto | null): User | null {
    if (!u) {
      return null;
    }
    return new User(
      u.userId,
      u.displayName,
      u.email,
      u.userName,
      u.connectedServices.map((cs) => ConnectedService.fromDto(cs)),
    );
  }
}
